import ApplicationController from './application_controller'

class FallbackImageController extends ApplicationController {
  static values = { "fallbackUrl": String }

  connect() {
    this.element.onerror = () => {
      this.element.onerror = null
      this.element.src = this.fallbackUrlValue
    }
  }
}

export default FallbackImageController
